<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <i class="el-icon-user-solid" style="margin-right: 5px"></i>

        <span>
          Choisir un utilisateur
        </span>
      </div>
      <!-- <div v-for="user in users"
           v-bind:key="user.id"
           class="text item"> -->
        <User v-for="user in users" :user="user"
        v-bind:key="user.id"
              data-test='user--test'
              @authTry="authTry($event)"></User>
      <!-- </div> -->
      <el-alert
        v-if="noUsers"
        title="Aucun utilisateur trouvé"
        :closable="false"
        type="warning">
      </el-alert>
    </el-card>
  </div>
</template>

<script>
import _ from 'lodash';
import User from './User/User.vue';

export default {
  components: {
    User,
  },
  props: {
    users: undefined,
  },
  computed: {
    noUsers() {
      return this.users !== undefined && _.isEmpty(this.users);
    },
  },
  methods: {
    authTry(auth) {
      this.$emit('authTry', auth);
    },
  },
};
</script>

<style lang="stylus">

</style>
